import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRewind"><Path d="M20.0003 20.0178V3.98242L12.0003 10.1001V3.98242L1.51562 12.0001L12.0003 20.0178V13.9002L20.0003 20.0178Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewind;
